import { HelperResult, UserAbout } from 'packages/openclassrooms/openclassrooms-sdk-web/src';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface GetUserAboutParams {
  userId: number;
}

interface UpdateUserAboutParams {
  userId: number;
  context: string;
}

const { useGet: useGetAbout, useUpdate: useUpdateAbout } = getCRUDHooks({
  entityName: 'about',
  get({ userId }: GetUserAboutParams): HelperResult<UserAbout> {
    return clientApi.getOCClient().helpers.user.users.id(userId).about.find();
  },
  update(about: UserAbout, { userId, context }: UpdateUserAboutParams): HelperResult<UserAbout> {
    return clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .about.update('', about, false)
      .setHeader('X-Request-Context', context)
      .execute();
  },
});

export { useGetAbout, useUpdateAbout };
